<button mat-stroked-button color="accent" (click)="openDialog()">Request a Quote</button>
